import clsx from "clsx";
import { useContext, useState } from "react";
import translate from "../../locales";
import { ClassroomContext } from "../classroom.context";

export function TextInput({
  id = "",
  required = true,
  placeholder = "",
  maxLength = 20,
  onChange,
}) {
  const {
    form: { touched },
    getField,
    setField,
    setTouched,
  } = useContext(ClassroomContext);
  const [value, setValue] = useState(getField(id));

  const onChangeText = (e) => {
    setValue(e.target.value);
    onChange?.(e.target.value);
    setField(id, e.target.value);
  };

  return (
    <div
      className={clsx(
        "input",
        required && touched[id] && !value && "input--invalid",
      )}
    >
      <input
        id={id}
        className={clsx("input__field")}
        type="text"
        maxLength={maxLength}
        placeholder={translate(placeholder)}
        onChange={onChangeText}
        onBlur={() => setTouched(id)}
        value={value}
      />
      <span className={clsx("input__helper")}>
        {translate("exercise.ui.text-input-footer", {
          count: value.length,
          limit: maxLength,
        })}
      </span>
    </div>
  );
}
